import React, { useState } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,
    TableContainer,
          Paper,
    TableCell
} from "@material-ui/core";
import SubjectService from "./Locality/Service/subjectService";
import * as Yup from 'yup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import { Grid, Card, Box, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useContext, useEffect } from 'react';
import { useTheme } from "@material-ui/styles";
import {
    ResponsiveContainer,
    ComposedChart,
    AreaChart,
    LineChart,
    Line,
    Area,
    PieChart,
    Pie,
    Cell,
    YAxis,
    XAxis,
} from "recharts";
import mock from "./mock";
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Typography } from "../../components/Wrappers/Wrappers";
import Dot from "../../components/Sidebar/components/Dot";
import BigStat from "./components/BigStat/BigStat";
import { withStyles, makeStyles } from '@material-ui/core/styles';
  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: "#0f3b62ad",
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function Subject() {
    const tableHeaders = [ 'Subject', 'Status', 'edit', 'delete'];
    const classes = useStyles();
    const [subjectList, setSubjectList] = useState([]);
        const [subjectIdList, setSubjectIdList] = useState([]);
    
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    const [open, setOpen] = React.useState(false);
    const [subject, setSubject] = useState({
        subject: '',
        status: '',
    });
    
    useEffect(() => {
        getSubjectList();
        return () => {
            setSubjectList([]);
            setSubjectIdList([]);
        }
    }, []);
    const handleOpen = (status) => {
      if(status){
        setSubject({
            subject: '',
          status: '',
      })
      }
   
        setOpen(true);
    };
    const onclick = () => {

        setOpen(true);
      }
    const handleClose = () => {
        setOpen(false);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };
    
    const getSubjectList = () => {
      const userDetails = JSON.parse(localStorage.getItem("userDetail"));
      
      SubjectService.getAllSubject().then((res) => {
            setSubjectList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const onSubmit = data => {
        console.log(JSON.stringify(data, null, 2));
      };
    const validationSchema = Yup.object().shape({
     
        subject: Yup.string().required('Subject is required'),
        status: Yup.string().required('status  is required'),
    });
   
    const editSubject = (subject ) => {
        setSubject(subject)
        handleOpen(false);
     
      }
      const deleteSubject = (subjectdelete) => {
        if (subjectdelete) {
          SubjectService.deleteSubject(subjectdelete).then((res) => {
            getSubjectList();
          }).catch((err) => {
          });
        }
      };
    const formik = useFormik({
        initialValues: subject,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
          
            if(subject._id){
                SubjectService.upadeSubject(values).then((res) => {
                    handleClose();
                    getSubjectList();
                    resetForm()
                    alert("Subject Updated Successfully.");
                    
                  }).catch((err) => {
                   
                  });
            }
            else {
                SubjectService.creteSubject(values).then((res) => {
                        getSubjectList();
                        handleClose();
                        resetForm();
                        alert(" Subject Added Successfully.");
                        // props.history.push('/app/vendor');
                    })
                
                .catch((err) => {
                    
                    alert(err.response.data.message)
                })
        }
    },
    });
    return (
        <>
            <PageTitle title="Subject" button={<Button

                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{backgroundColor:'rgb(15 59 98)'}}> Add Subject
            </Button>} />
            <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                            <TableContainer component={Paper} style={{ maxHeight: 500 }}>
            
            <Table stickyHeader className="mb-0">
              <TableHead >
                <TableRow>
                  {tableHeaders.map(key => (
                    <StyledTableCell key={key}>{key}</StyledTableCell>
                  ))}
                </TableRow>

              </TableHead>
              <TableBody>
                {subjectList.map((subject) => (
                  <TableRow key={subject._id}>
        
                    <TableCell className="pl-3 fw-normal" >{subject.subject}</TableCell>

                    <TableCell>
                      {subject.status ? 'Active' : 'In Active'}
                    </TableCell>
                    <TableCell>
                      <EditIcon style={{ cursor: 'pointer' }} onClick={() => editSubject(subject)} >
                      </EditIcon >
                    </TableCell>
                    <TableCell>
                      <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteSubject(subject)} />
                    </TableCell>
                    
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            </TableContainer >
          </Widget>
        </Grid>
      </Grid>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add Subject</DialogTitle>
                <form onSubmit={formik.handleSubmit} >
                    <DialogContent style= {{ width: 308 }}>
                        
                        <TextField
                            InputProps={{ style: { width: 258 } }}
                            autoFocus
                            margin="dense"
                            id="subject"
                            name="subject"
                            label="Subject"
                            type="text"
                            variant="standard"
                            value={formik.values.subject}
                            onChange={formik.handleChange}
                            error={formik.touched.subject && Boolean(formik.errors.subject)}
                            helperText={formik.touched.subject && formik.errors.subject}
                        />
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="demo-simple-select-standard-label">Status</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                label="status"
                                name="status"
                                value={formik.values.status}
                                onChange={formik.handleChange}
                                error={formik.touched.status && Boolean(formik.errors.status)}
                                helperText={formik.touched.status && formik.errors.status}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                <MenuItem value={true}>Active</MenuItem>
                                <MenuItem value={false}>In Active</MenuItem>
                            </Select>
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit" >Add</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}


